
<perfect-scrollbar class="side-nav" sideNav>
  <div class="logo-side">

  </div>
  <ul class="ant-menu ant-menu-root ant-menu-inline side-nav-menu"
  [ngClass]="{
    'ant-menu-inline-collapsed': isFolded,
    'ant-menu-dark' : isSideNavDark
  }"
  >

      <li class="desktop-toggle">
          <div class="desktop-toggle-wrap" [ngClass]="{'desktop-toggle-wrap-folded': isFolded}">
              <a (click)="toggleFold('')" [ngClass]="{'desktop-toggle-link-folded': isFolded}" >
                <span class="desktop-toggle-icon" [ngClass]="{'is-hidden': isFolded}" nz-icon nzType="menu-fold" nzTheme="outline"></span>
                <span class="desktop-toggle-icon" [ngClass]="{'is-hidden': !isFolded}" nz-icon nzType="menu-unfold" nzTheme="outline"></span>
              </a>
          </div>
      </li>

      <li class="menu-mobile company-name-item">
            <p class="company-name-text">{{titleCase(companyName)}}</p>
      </li>

      <li [ngClass]="[item.submenu.length > 0 ? 'ant-menu-submenu ant-menu-submenu-inline':'ant-menu-item', isItemActive(item) ? 'ant-menu-item-selected':'']"
          *ngFor="let item of menuItems"
          class="menu-item-row">

          <a href="javascript:void(0);" role="button" aria-haspopup="true" class="ant-menu-submenu-title link-desktop menu-submenu-title-desktop" *ngIf="!isFolded && (item.submenu.length > 0)" nz-tooltip [nzTitle]="item.title" nzPlacement="right"
              [ngClass]="isItemActive(item) ? 'item-selected-menu':''">
              <i *ngIf="item.iconType == 'nzIcon'" nz-icon [type]="item.icon" [theme]="item.iconTheme"></i>
              <i *ngIf="item.iconType == 'fontawesome'" class="m-r-10" [ngClass]="[item.iconTheme , item.icon]"></i>
              <i *ngIf="item.iconType == 'custom'" class="m-r-10" [ngClass]="['custom-icon',item.icon]"></i>
              <span *ngIf="!isFolded"><strong>{{item.title}}</strong></span>
              <i class="ant-menu-submenu-arrow"></i>
          </a>
          <!-- MOBILE menu padre-->
          <a nz-button class="menu-mobile ant-menu-submenu-title menu-submenu-title-mobile"
              *ngIf="!isFolded && (item.submenu.length > 0)"
              nzType="default"
              role="button" aria-haspopup="true"
              href="javascript:void(0);">
              <div>
                  <span *ngIf="!isFolded">{{item.title}}</span>
              </div>
          </a>
          <!-- end mobile -->

          <!-- FOOLED -->
          <a href="javascript:void(0);" role="button" aria-haspopup="true" class="ant-menu-submenu-title menu-submenu-title-folded" *ngIf="isFolded && (item.submenu.length > 0)">
              <i *ngIf="item.iconType == 'nzIcon'" nz-icon [type]="item.icon" [theme]="item.iconTheme"></i>
              <i *ngIf="item.iconType == 'fontawesome'" class="m-r-10" [ngClass]="[item.iconTheme , item.icon]"></i>
              <i *ngIf="item.iconType == 'custom'" class="m-r-10" [ngClass]="['custom-icon',item.icon]"></i>
              <span *ngIf="!isFolded">{{item.title}}</span>
              <i class="ant-menu-submenu-arrow"></i>
          </a>
          <a (click)="linkClick(item.path)" *ngIf="!item.submenu.length > 0" nz-tooltip [nzTitle]="item.title" nzPlacement="right"
              class="ant-menu-submenu-title link-desktop menu-item-link-desktop"
              [ngClass]="isItemActive(item) ? 'item-selected-menu':''">
              <i *ngIf="item.iconType == 'nzIcon'" nz-icon [type]="item.icon" [theme]="item.iconTheme"></i>
              <i *ngIf="item.iconType == 'fontawesome'" class="m-r-10" [ngClass]="[item.iconTheme , item.icon]"></i>
              <i *ngIf="item.iconType == 'custom'" class="m-r-10" [ngClass]="['custom-icon',item.icon]"></i>
              <span *ngIf="!isFolded"><strong>{{item.title}}</strong></span>
          </a>
          <!-- MENU MOBILE -->
          <a nz-button class="menu-mobile menu-item-mobile"
              *ngIf="!item.submenu.length > 0"
              nzType="default"
              (click)="toggleFold(item.path)">
              <div>
                  <span *ngIf="!isFolded">{{item.title}}</span>
              </div>
          </a>
          <!-- END MENU MOBILE -->

          <!-- Second Level -->
          <ul class="ant-menu ant-menu-inline ant-menu-sub dropdown-menu menu-mobile-fold submenu-level-2" *ngIf="item.submenu.length > 0"
              [ngStyle]="{'top': (item.submenu.length > 8) ? '-220px' : ''}">
              <!-- <li *ngIf="isFolded" class="ant-menu-item" style="cursor: auto; margin-top: 10px; margin-bottom: 0px;height: 100%; text-align: center; margin-left: -10px;">
                  <span><h5 class="p-l-30" style="color: #000000;">{{item.title}}</h5></span>
              </li>
              <nz-divider style="background-color: #e62d39;" *ngIf="isFolded"></nz-divider> -->
              <ng-container *ngFor="let subItem of item.submenu" >
                  <li [ngClass]="subItem.submenu.length > 0?'ant-menu-submenu ant-menu-submenu-inline':'ant-menu-item'"
                      *ngIf="!subItem.admin || admin">


                      <a href="javascript:void(0);" role="button" aria-haspopup="true" class="ant-menu-submenu-title p-l-50" *ngIf="subItem.submenu.length > 0">
                          <i *ngIf="subItem.iconType == 'nzIcon'" nz-icon [type]="subItem.icon" [theme]="subItem.iconTheme"></i>
                          <i *ngIf="subItem.iconType == 'fontawesome'" class="m-r-10" [ngClass]="[subItem.iconTheme , subItem.icon]"></i>
                          <i *ngIf="subItem.iconType == 'custom'" class="m-r-10" [ngClass]="[subItem.icon]"></i>
                          <p>{{subItem.title}}</p>
                          <i class="ant-menu-submenu-arrow"></i>
                      </a>
                      <a (click)="toggleFold(subItem.path)"  class="p-l-30" *ngIf="!subItem.submenu.length > 0" (click)="onClick()"
                          [ngClass]="isSubItemActive(subItem) ? 'item-selected-menu':''">
                          <i *ngIf="subItem.iconType == 'nzIcon'" nz-icon [type]="subItem.icon" [theme]="subItem.iconTheme"></i>
                          <i *ngIf="subItem.iconType == 'fontawesome'" class="m-r-10" [ngClass]="[subItem.iconTheme , subItem.icon]"></i>
                          <i *ngIf="subItem.iconType == 'custom'" class="m-r-10" [ngClass]="[subItem.icon]"></i>
                          <strong><span>{{subItem.title}}</span></strong>
                      </a>

                      <!-- Third Level -->
                      <ul class="ant-menu ant-menu-inline ant-menu-sub dropdown-menu" *ngIf="subItem.submenu.length > 0">
                          <li [ngClass]="subItem.submenu.length > 0 ? 'ant-menu-submenu ant-menu-submenu-inline':'ant-menu-item'"
                              *ngFor="let subItem of subItem.submenu" routerLinkActive="ant-menu-item-selected"
                              [routerLinkActiveOptions]="{exact: true}">
                              <a href="javascript:void(0);" role="button" aria-haspopup="true" class="ant-menu-submenu-title p-l-50
                              " *ngIf="subItem.submenu.length > 0">
                                  <i *ngIf="subItem.iconType == 'nzIcon'" nz-icon [type]="subItem.icon" [theme]="subItem.iconTheme"></i>
                                  <i *ngIf="subItem.iconType == 'fontawesome'" class="m-r-10" [ngClass]="[subItem.iconTheme , subItem.icon]"></i>
                                  <i *ngIf="subItem.iconType == 'custom'" class="m-r-10" [ngClass]="[subItem.icon]"></i>
                                  <span>{{subItem.title}}</span>
                                  <i class="ant-menu-submenu-arrow"></i>
                              </a>
                              <a (click)="linkClick(subItem.path)"  class="p-l-50" *ngIf="!subItem.submenu.length > 0">
                                  <i *ngIf="subItem.iconType == 'nzIcon'" nz-icon [type]="subItem.icon" [theme]="subItem.iconTheme"></i>
                                  <i *ngIf="subItem.iconType == 'fontawesome'" class="m-r-10" [ngClass]="[subItem.iconTheme , subItem.icon]"></i>
                                  <i *ngIf="subItem.iconType == 'custom'" class="m-r-10" [ngClass]="[subItem.icon]"></i>
                                  <span>{{subItem.title}}</span>
                              </a>
                          </li>
                      </ul>
                  </li>

              </ng-container>
          </ul>
      </li>

    <li [ngClass]="[isFolded? 'ant-menu-submenu ant-menu-submenu-inline':'']"
        class="help-menu-item">

        <a href="https://transtecnia.cl/contabilidad-fintech-inteligencia-artificial/"
            class="ant-menu-submenu-title link-desktop help-link-desktop"
            *ngIf="!isFolded" nz-tooltip nzPlacement="right" >
            <i class="m-r-10" [ngClass]="['custom-icon', 'como-icon']"></i>
            <span *ngIf="!isFolded"><strong>Ayuda</strong></span>
            <i class="ant-menu-submenu-arrow"></i>
        </a>
        <!-- FOOLED -->
        <a href="https://transtecnia.cl/contabilidad-fintech-inteligencia-artificial/"
             class="ant-menu-submenu-title help-link-folded" *ngIf="isFolded">
            <i class="m-r-10" [ngClass]="['custom-icon','como-icon']"></i>
            <span *ngIf="!isFolded">Ayuda</span>
            <i class="ant-menu-submenu-arrow"></i>
        </a>
    </li>
      <!--
      <li class="ant-menu-item menu-mobile"
      style="margin-top: 5px; border: 0 !important;">
            <a nz-button class="menu-mobile"
                nzType="default"
                onclick="this.blur();"
                style="margin-top: 0px; padding-top: 0 !important; margin-left: -18px; max-width: 95%; left: 5%"
                (click)="showModal()">
                <div>
                    <span *ngIf="!isFolded">Cambiar Empresa</span>
                </div>
            </a>
      </li>
        -->

    </ul>
    <div class="ant-menu menu-footer"
    [ngClass]="{
      'menu-footer-folded': isFolded
    }"
    >
        <div nz-row>
            <nz-col nzSpan="22" nzOffset="2">
                <strong>2 2715 7200</strong>
            </nz-col>
        </div>
        <div nz-row>
            <nz-col nzSpan="2" nzOffset="2">
                <i class="custom-icon twitter-icon"></i>
            </nz-col>
            <nz-col nzSpan="2">
                <i class="custom-icon linkedin-icon"></i>
            </nz-col>
            <nz-col nzSpan="2">
                <i class="custom-icon facebook-icon"></i>
            </nz-col>
            <nz-col nzSpan="2">
                <i class="custom-icon instagram-icon"></i>
            </nz-col>
            <nz-col nzSpan="2">
                <i class="custom-icon youtube-icon"></i>
            </nz-col>
            <nz-col class="link-transtecnia" nzSpan="7" nzOffset="5">
                <a href="http://www.transtecnia.cl" target="_blank">
                    <strong class="transtecnia-link-text">transtecnia.cl</strong>
                </a>
            </nz-col>
        </div>
    </div>
</perfect-scrollbar>

<nz-modal
      [(nzVisible)]="isVisible"
      nzTitle="Selección de empresa"
      [nzContent]="modalContent"
      nzWidth="100%"
      (nzOnCancel)="hideModal()"
      (nzOnOk)="chooseCompany()"
    >
        <ng-template #modalContent>
            <div nz-row>
                <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="email">Empresa</nz-form-label>
                <div nz-col [nzSm]="12" [nzXs]="24">
                    <nz-input-group>
                        <nz-select
                            class="w-100"
                            [(ngModel)]="selectedCompany"
                            nzShowSearch
                            nzAllowClear
                            nzPlaceHolder="seleccione una empresa"
                            >
                                <nz-option *ngFor="let company of companies" [nzLabel]="company.name" [nzValue]="company.id"></nz-option>
                        </nz-select>
                    </nz-input-group>
                </div>
            </div>
        </ng-template>

        <!-- <ng-template #modalFooter>
            <div nz-row >

                        <div nz-col [nzSm]="12">
                            <button nz-button nzType="primary" (click)="chooseCompany()">Aceptar</button>
                        </div>
                         <div nz-col [nzSm]="12" >
                            <button nz-button nzType="default" (click)="hideModal('company')">Cancelar</button>
                        </div>

            </div>
        </ng-template> -->
</nz-modal>